import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Track page views
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view
    const trackPageView = async () => {
      try {
        await axios.post(`${API_URL}/analytics/pageview`, {
          page: location.pathname,
          referrer: document.referrer || null
        });
      } catch (error) {
        // Silently fail - don't break the app for analytics
        console.debug('Analytics tracking failed:', error);
      }
    };

    trackPageView();
  }, [location.pathname]);
};

// Track mix plays
export const trackMixPlay = async (mixId, mixTitle) => {
  try {
    await axios.post(`${API_URL}/analytics/mixplay`, {
      mix_id: mixId,
      mix_title: mixTitle
    });
  } catch (error) {
    console.debug('Mix play tracking failed:', error);
  }
};

export default usePageTracking;
